import apiClient from './client';
import { Credential } from '../types/contractor';

export async function getMyCredentials(): Promise<Credential[]> {
  const response = await apiClient.get<Credential[]>('/Credential/me');
  return response.data;
}

export async function uploadCredentialDocument(credentialId: number, file: File): Promise<void> {
  const formData = new FormData();
  formData.append('file', file);
  await apiClient.post(`/Credential/${credentialId}/document`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export async function updateRegistrationNumber(credentialId: number, registrationNumber: string): Promise<void> {
  await apiClient.put(`/Credential/${credentialId}/registration`, { registrationNumber });
}

export async function submitCredentialsForReview(): Promise<{ success: boolean; message?: string; validationErrors?: string[] }> {
  const response = await apiClient.post<{ message: string }>('/Credential/submit');
  return { success: true, message: response.data.message };
}

export async function downloadCredentialDocument(credentialId: number): Promise<void> {
  const response = await apiClient.get(`/Credential/${credentialId}/document`, {
    responseType: 'blob',
  });

  const blob = new Blob([response.data], {
    type: String(response.headers['content-type'] ?? 'application/octet-stream'),
  });

  const url = URL.createObjectURL(blob);
  window.open(url, '_blank');

  // Revoke after a short delay to allow the tab to load
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}
